import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ServicioService } from '../servicio.service';

@Component({
  selector: 'app-servicio-view',
  templateUrl: './servicio-view.component.html',
  styleUrls: ['./servicio-view.component.scss']
})
export class ServicioViewComponent implements OnInit {

  @Input() element: any = {}
  form: FormGroup = new FormGroup({});

  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: ServicioService,
    public formatter: FormatterService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      precio_venta: [''],
      descripcion: [''],
    });

    this.form.patchValue(this.element);
    this.form.disable();
  }

}
